<template>
  <div class="record-report-box">
    <div class="wonderful">
      <!-- banner -->
      <img :src="require('@/assets/images/wonderful.jpg')" alt="" />
      <!-- 查看更多 -->
      <div class="more" ref="more" :class="{ active: moreFocus }">
        <div class="cover" @click="moreFocus = false"></div>
        <span @click="moreFocus = true">
          查看更多<i
            class="el-icon-caret-bottom"
            :class="{ active: moreFocus }"
          ></i>
        </span>
        <div class="panel">
          <transition name="fadeClose">
            <div class="list">
              <div
                class="item"
                :class="{ active: ind === slideIndex }"
                v-for="(item, ind) in optionList"
                :key="ind"
                @click="swiper && swiper.slideTo(ind), (moreFocus = false)"
              >
                {{ item.round ? item.round : `第${item.num}轮` }}
              </div>
            </div>
          </transition>
        </div>
      </div>
      <img
        class="tit"
        :src="require('@/assets/images/wonderful-title.png')"
        alt=""
      />
    </div>
    <swiper
      class="zjzb-swiper"
      :options="recordSwiperOption"
      :not-next-tick="true"
      @slideChange="changeSlide"
      ref="roundSwiper"
    >
      <swiper-slide v-for="(item, index) in list" :key="index">
        <GameCard
          :times="index + 1"
          :item="item"
          @play="playEvent"
          @context="$emit('context', $event)"
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- <transition name="fadeClose">
      <span class="sub-title" v-if="!isVideoHide">战报视频</span>
    </transition> -->
    <!-- <div class="vid-container">
      <transition name="fadeClose">
        <div class="video-preview-con" @click="playEvent" v-if="!isVideoHide">
          <div class="preview">
            <img class="bg" :src="currentItem && currentItem.img ? currentItem.img : background" alt="">
          </div>
        </div>
      </transition>
    </div> -->
  </div>
</template>
<script>
import SectionTitle from '@/components/items/sectionTitle'
import GameCard from '@/components/items/GameCard'
export default {
  name: 'history',
  components: { SectionTitle, GameCard },
  props: ['listData', 'team'],
  watch: {
    listData(nv) {
      setTimeout(() => {
        const target = nv.findIndex((e) => e.active)
        this.swiper.slideTo(target)
      }, 0)
    },
  },
  data() {
    return {
      slideIndex: 0,
      moreFocus: false,
    }
  },
  computed: {
    isVideoHide() {
      return !!(
        !this.currentItem ||
        (!this.currentItem.url && !this.currentItem.img)
      )
    },
    background() {
      const name = this.team || 'premier_league'
      return require(`../../assets/images/common/bg/${name}.jpg`)
    },
    currentItem() {
      return (this.slideIndex != null && this.listData[this.slideIndex]) || {}
    },
    list() {
      return this.listData
    },
    swiper() {
      const en = this.$refs.roundSwiper
      return (en && en.$swiper) || (en && en.$el.swiper)
    },
    optionList() {
      return this.list.map((e, i) => ({
        round: e.round,
        num: this.getTime(i + 1),
        id: e.id,
      }))
    },
    recordSwiperOption() {
      return {
        speed: 1000,
        spaceBetween: 5,
        autoplay: 1000,
        // loop: true,
        grabCursor: true,
        slideToClickedSlide: true,
        autoplayDisableOnInteraction: false,

        slidesPerView: 'auto',
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        onSlideChangeEnd: function (swiper) {
          // swiper.update(); //swiper更新
        },
      }
    },
  },
  methods: {
    playEvent() {
      const url = this.currentItem.url
      this.$emit('play', url)
    },
    changeSlide(event) {
      this.slideIndex = this.$refs.roundSwiper.$el.swiper.realIndex
    },
    getTime(n) {
      const arr = ' 一二三四五六七八九十'.split('')
      const num = (n + '').split('').map((e) => Number(e))
      const double = num.length >= 2
      let result = !double
        ? arr[num[0]]
        : (num[0] === 1 ? '' : arr[num[0]]) +
          arr[10] +
          (num[1] !== 0 && num[1] ? arr[num[1]] : '')
      return result
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/css/home';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="less">
@import '../../styles/home';
</style>
<style lang="less" scoped>
@import 'swiper/dist/css/swiper.css';
.section-title-wrap {
  width: 60%;
  display: block;
  margin: 0 auto;
}
.game-card {
  // width: 80%;
  min-height: 150px;
  margin: 0 auto;
}
.swiper-slide {
  width: 60%;
  transform: scale(0.9) !important;
  transition: transform 0.16s ease;
  &.swiper-slide-active {
    transform: scale(1) !important;
  }
}
.record-report-box {
  padding-bottom: 1em;
  text-align: center;
  background:#eee;
}
.zjzb-swiper.swiper-container {
  overflow: visible;
  margin-bottom: 30px;

  .swiper-pagination {
    bottom: auto;
    top: 100%;
    max-width: 80%;
    left: 10%;
    font-size: 16px;
    /deep/.swiper-pagination-bullet {
      border: 1.5px solid #777;
      background: white;
      &.swiper-pagination-bullet-active {
        background: #d8d8d8;
        border: 1.5px solid #d8d8d8;
      }
    }
  }
}

.vid-container {
  width: 92.5%;
  margin: 1em auto 0;
  margin-top: 0;
  background: white;
  min-height: 20px;
  margin-bottom:20px;
}
.more {
  font-size: 0.4rem;
  font-weight: 600;
  color: #ffb55e;
  position: relative;
  display: flex;
  margin-left: 0.5em;
  .cover {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    opacity: 0;
    z-index: 10;
  }
  span i {
    transition: all 0.3s ease;
    &.active {
      transform: rotate(-180deg);
    }
  }
  &.active {
    .cover {
      display: block;
    }
    .panel {
      max-height: 35vh;
      opacity: 1;
    }
  }
  .panel {
    position: absolute;
    transform: all 0.16s ease;
    top: 100%;
    left: 0;
    max-height: 0;
    overflow: visible;
    opacity: 0;
    width: max-content;
    max-width: 50vw;
    display: flex;
    // padding: 0.4em 1em;
    // padding-right: 0;
    border-radius: 3px;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: white;
    // box-shadow: 1px 1px 3px #777;
    border: 1px solid #f8cf70;
    z-index: 11;
    margin-top: 0.5em;
    &::before {
      position: absolute;

      content: '';
      width: 0;
      height: 0;
      border-width: 0 0.5em 0.5em 0.5em;
      border-style: solid;
      border-color: transparent transparent #f8cf70 transparent;
      position: absolute;
      left: 0.6em;
      top: -0.5em;
    }
    .list {
      // padding-right: 1em;
      position: relative;
      max-height: 100%;
      height: auto;
      overflow-y: auto;
    }
    .item {
      color: #b8b8b8;
      // margin-bottom: 0.3rem;
      font-size: 0.6em;
      letter-spacing: 0.1em;
      padding: 0.6em 1.4em;

      &.active {
        background: linear-gradient(#f8cf70, #f3a35c);
        font-weight: 600;
        color: #292929;
      }
    }
  }
}
.sub-title {
  line-height: 0.6em;
  font-size: 0.4em;
  text-align: center;
  color: #fff;
  background-image: url('../../assets/images/common/title.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0.5em 1.5em;
}
</style>
<style lang="stylus" scoped>
.wonderful {
  position relative
  .tit {
    position absolute
    left 50%
    top 50%
    transform translate3d(-50%, -50%, 0)
    width 116px !important
  }
  .more{
    position absolute
    left 10px
    top 10px
    color #fff !important
    font-size 15px !important
  }
}
</style>



// WEBPACK FOOTER //
// src/components/section/history.vue